import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useState } from "react";
import API from "../Network/API";
import { useDispatch } from "react-redux";
import { USER_LOGGED_IN } from "../Reducer/authSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export default function SubscribeCard({ priceId, price }) {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return; // Stripe.js has not loaded yet.
        }

        setError(null);
        setLoading(true);

        // Get the card element
        const cardElement = elements.getElement(CardElement);

        // Create the payment method
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
        });

        if (error) {
            setError(error.message);
            setLoading(false);
            return;
        }

        // Pass the paymentMethod.id and priceId to your backend
        const fd = new FormData();
        fd.append('priceId', priceId);
        fd.append('payment_method', paymentMethod.id); // Pass the valid payment method ID

        API.post("/v1/oauth/teacher/subscription", fd, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then((response) => {
            setLoading(false);
            toast.success(t("subscribeCard.subscription_activated"));
            localStorage.setItem(
                'xller_auth',
                JSON.stringify({
                    user: response?.data?.data?.user,
                    accessToken: localStorage.getItem('xller_token'),
                })
            )

            const userInfo = JSON.parse(localStorage.getItem("xller_auth"));
            if (userInfo) {
                dispatch(USER_LOGGED_IN(userInfo));
            }
        }).catch((err) => {
            setLoading(false);
            const msg = err?.response?.data?.message || t("subscribeCard.subscription_failed");
            setError(msg);
            toast.error(msg);
        });
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <label className="form-label subscribe-card-label">{t("subscribeCard.pay_with_card")}</label>
                <div className="card-element-box">
                    <CardElement options={{ style: { base: { fontSize: '15px', color: '#101828', '::placeholder': { color: '#98A2B3' } } } }} />
                </div>
                {error && <div className="subscribe-card-error">{error}</div>}
                <button type="submit" className="w-100 btn subscribe-btn mt-3" disabled={!stripe || isLoading}>
                    {isLoading ?
                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{t("subscribeCard.processing")}</>
                        :
                        <>{price ? <>{t("subscribeCard.subscribe")} · <span className="fw-bold">{t("subscribeCard.price_per_month", { price })}</span></> : t("subscribeCard.subscribe_now")}</>
                    }
                </button>
                <p className="subscribe-card-note">{t("subscribeCard.secure_payment_note")}</p>
            </form>
        </>
    );
}
